import { fetchManagementPositioningDisplayAction } from "../positioningDisplay/positioningDisplay";
import { IManagmentPositioningDisplay, IManagmentPositioningDocks } from "../../../../models/management/positioningDisplay/IManagmentPositioningDisplay";
import { IOrganismScreen, IOrganismScreenRow } from "../../../../models/management/organismScreen/IOrganismScreen";

// Pantalla Organismos no tiene endpoint propio: reutiliza la misma llamada que Pantalla Posicionados
// (fetchManagementPositioningDisplayAction -> management/positioningdisplayscreen), que ya filtra por
// fecha = hoy y estado = muelle, y adapta su respuesta (agrupada por muelle) a una fila por inspección
// (muelle + organismo + certificado).
export const mapPositioningDisplayToOrganismScreen = (positioningDisplay: IManagmentPositioningDisplay | false): IOrganismScreen => {
    if (!positioningDisplay || !positioningDisplay.positioningDocks) {
        return [];
    }

    const docksWithData: IManagmentPositioningDocks[] = positioningDisplay.positioningDocks
        .filter((dock) => !!dock.transportUnitNumber && dock.positioningOrganisms?.length > 0)
        .sort((a, b) => new Date(a.dockDate ?? 0).getTime() - new Date(b.dockDate ?? 0).getTime());

    const rows: IOrganismScreenRow[] = [];
    docksWithData.forEach((dock, dockIndex) => {
        dock.positioningOrganisms.forEach((organism) => {
            const certificates = organism.certificates?.length ? organism.certificates : [""];
            certificates.forEach((certificate) => {
                rows.push({
                    requestId: dockIndex,
                    transportUnitNumber: dock.transportUnitNumber!,
                    expedient: certificate || "-",
                    dockDescription: dock.dockDescription ?? "-",
                    organismCode: organism.code,
                    organismDescription: organism.description,
                    inspectorArrivedOn: organism.inspectorArrivedOn ?? null,
                    dockAssignmentOn: dock.dockDate ?? null,
                });
            });
        });
    });

    return rows;
};

export const fetchManagementOrganismScreenAction = async (organization?: string): Promise<IOrganismScreen> => {
    const positioningDisplay = await fetchManagementPositioningDisplayAction(organization);
    return mapPositioningDisplayToOrganismScreen(positioningDisplay);
};
